import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {
    ExperienceLevelType,
    IFontFormat,
    ISceneBlock,
    ISceneItemNewValues,
    ISceneItemsUpdate,
    ISceneTreeSliceResults
} from "../../../../interfaces";
import {actionUpdateSceneItem} from "../../../../store/actions/user.actions";
import {DynamicFormComponent} from "../../../../components/dynamics/dynamic-form/dynamic-form.component";
import {MatDialog} from "@angular/material/dialog";
import {dateStringToUnix, dateUnixToString, doNothing, isNullOrUndef, mimeSwap, removeUndefNulls, timeSecondsToFormat} from "../../../../common";
import {IBlockLabelsRecords} from "../block-constants";
import {FieldConfig} from "../../../../interfaces/field.interface";
import {instanceOfTableList} from "../../../../components/table-list-input/table-list-input.component";
import {DynamicFieldDirective} from "../../../../components/dynamics/dynamic-field/dynamic-field.directive";
import {LocalStoreService, StoreSelectorsService} from "../../../../services";
import {Lib} from "../../../../../libs/Lib";
import {filter, map, take, tap} from 'rxjs/operators';
import { DialogTouchActionComponent } from "../../touch/touch-action-dialog/touch-action-dialog.component";
import {animationFrameScheduler, combineLatest, interval} from "rxjs";
import {Compbaser} from "../../../../components/compbaser";
import * as _ from "lodash";

@Component({
    selector: 'app-scene-block-base',
    template: '',
})
export class BlockBaseComponent extends Compbaser implements OnInit {
    dynamicsInitialized = false;
    sceneItemSwitched: boolean;
    uiConfigInit: FieldConfig[] = [];
    sceneId: string;
    sceneItem: ISceneBlock;
    sceneItemId: string;
    mimeTypeShort: string;
    mimeTypeLong: string;
    blockLabelRecords: IBlockLabelsRecords;
    isFullFeatures: boolean;

    // Touch action functionality - safe to add as it's optional
    isTouchMode = false;

    // subMimeType: string; /**  google_news | as in: SceneMimeTypes.NetFeed > google_news **/

    /** flag true if switched sceneItem instance to another, gives us an opportunity to act in sub-class using componentStoreUpdates if scene id switched  **/

    readonly experienceLevelType = ExperienceLevelType; // Expose enum to template
    experienceLevel: ExperienceLevelType;

    constructor(public storeSelector: StoreSelectorsService,
                public override dialog?: MatDialog,
                protected localStoreService?: LocalStoreService) {
        super(dialog);
        this.blockLabelRecords = this.storeSelector.blockLabels;
    }

    @ViewChild(DynamicFormComponent) form: DynamicFormComponent;

    @Input() data: any;

    public dispatchSceneItemChanges(i_sceneItemsUpdate: ISceneItemsUpdate, isGroup = false) {
        this.storeSelector.dispatch(actionUpdateSceneItem({
            sceneId: i_sceneItemsUpdate.sceneId,
            sceneItemId: i_sceneItemsUpdate.sceneItemId,
            values: i_sceneItemsUpdate.values,
        }));
        if (!isGroup) {
            this.storeSelector.dispatch({type: 'BREAK_MERGE'});
        }
    }

    ngOnInit() {
        this.onInit();
        const intervals$ = interval(1, animationFrameScheduler).pipe(take(31));
        const sceneUpd$ = this.storeSelector.listenPlayerDataOfSelectedSceneItemId();

        // setTimeout(() => {
        //     const start = Date.now();
        //     this.cod(
        //         interval(1)
        //             .pipe(take(31),
        //                 scan((a, b) => {
        //                     const d = Date.now();
        //                     console.log(`took ${b} ${a.v - start} ${this.sceneItemId}`);
        //                     return {v: d};
        //                 }, {v: 0}))
        //             .subscribe(value => {
        //                 // console.log(value + ' ' + Date.now());
        //             })
        //     );
        // }, 3000);

        this.cod(
            this.storeSelector.isFullFeatures().subscribe((v) => {
                this.isFullFeatures = v;
            })
        );
        this.cod(
            combineLatest([intervals$, sceneUpd$]).pipe(
                map(([a, b]) => ({a, b})),
                tap((values) => {
                    const counter = String(values.a);
                    const scene: ISceneTreeSliceResults = values.b;
                    if (!!this.sceneItem?.$?.id && String(this.sceneItem?.$?.id) != String(scene.sceneItem?.$?.id)) this.sceneItemSwitched = true;
                    this.sceneId = scene.sceneId;
                    this.sceneItem = scene.sceneItem;
                    this.sceneItemId = scene.sceneItem?.$?.id;
                    switch (counter) {
                        case '5': {
                            this.preInit();
                            break;
                        }
                        case '10': {
                            this.initSceneMimeType();
                            this.initRegisterDynamic();
                            this.initApplyStoreToDynamic();
                            break;
                        }
                        case '20': {
                            this.componentInit();
                            this.dynamicsInitialized = true;
                            break;
                        }
                        case '30': {
                            /** the only method that gets called repeatedly and not just on first init lifecycle **/
                            this.componentStoreUpdates();
                        }
                    }
                })
            ).subscribe()
        );

        if (this.localStoreService != null) {
            this.cod(
                this.storeSelector.getLocalStoreUpdates('ILocalStorageConfig').subscribe((e) => {
                    this.experienceLevel = this.localStoreService.getStorageValConfig('experienceLevel'); // Alon
                })
            );
        }
    }

    // override: scene item changed from previous selection
    // public sceneItemSelectionChanged() {
    // }

    // override: pre-dynamics, early work to be done here
    public onInit() {
    }

    // override: pre-dynamics, early work to be done here
    public preInit() {
    }

    // override: register dynamic components
    public initRegisterDynamic() {
    }

    // override: init composition elements (components) specific to the sub-class, not part of the dynamic form UI
    public componentInit() {
        // Lib.DevShow('selected block type ' + this.sceneItem.$.player);

        // Touch mode detection - safe to add as it's optional
        this.cod(
            this.storeSelector.getEditorMode().subscribe(mode => {
                this.isTouchMode = mode === 'touch-editor';
            })
        );
    }

    // override: all subsequent updates
    public componentStoreUpdates() {
        this.sceneItemSwitched = false;
    }

    public initSceneMimeType() {
        this.cod(
            this.storeSelector.getSceneMime(this.sceneId)
                .pipe(take(1))
                .subscribe((i_mime) => {
                    this.mimeTypeLong = i_mime;
                    this.mimeTypeShort = mimeSwap("longToShort", i_mime);
                })
        );
    }

    /************************************************************/
    /** [db] => UI  update data coming from the store & to UI **/

    /************************************************************/
    public initApplyStoreToDynamic(applyStoreToDynamic: boolean = false, customUIConfig: FieldConfig[] = null) {
        const uiConfigToUse = customUIConfig || this.uiConfigInit;
        uiConfigToUse.forEach((k) => {
            if (!k) return;
            const storePath = k.storePath;
            if (_.isUndefined(storePath)) return;
            k.value = _.get(this.sceneItem, k.storePath);
            try {
                switch(k.type) {
                    case 'checkbox': {
                        k.value = k.value === '1' || k.value === 'true' || k.value === true || (k.options && k.value === k.options['1']);
                        if (k.value === undefined) {
                            k.value = false;
                        }
                        break;
                    }
                    case 'radiobutton': {
                        k.value = k.options[k.value];
                        break;
                    }
                    case 'select': {
                        // if (k.options["0"].optionValue) {
                        //     k.value = k.options.find((v) => v.optionValue === k.value).optionsLabel;
                        // }
                        break;
                    }
                    case 'input': {
                        if (k.inputType === 'date') k.value = dateUnixToString(k.value);
                        if (k.inputType === 'time') k.value = timeSecondsToFormat(k.value);
                        if (k.inputType === 'color') k.value = k.value ? String(Lib.DecimalToHex(k.value)) : '#000000';
                        if ((k.inputType === 'text' || k.inputType === 'textarea' || k.inputType === 'text_autocomplete') && isNullOrUndef(k.value)) k.value = '';
                        break;
                    }
                    default:
                        break;
                }
                if (applyStoreToDynamic)
                    this.setFormValue(k.name, k.value, k.inputType);
            } catch (e) {
                if (k.ignoreMissingValue) return;
                if (Lib.DevMode()) {
                    const msg = `There are missing Json fields in uiConfigInit, [[ NAME: ${k?.name} VALUE: ${k?.value} ]]`;
                    alert(msg + ' ' + k.storePath + ' ' + e);
                    console.log('adding ' + msg + ' ' + k.storePath + ' ' + e);
                }
            }
        });
    }

    /********************************************************/
    /** UI => [db] update data dispatching into the store **/
    /********************************************************/
    submit(formValues: any, patchBeforeSubmitFunc?: (i_value: Array<ISceneItemNewValues>) => Array<ISceneItemNewValues>, skipHiddenFields = false, skipTableList = false, customUIConfig: FieldConfig[] = null) {
        formValues = removeUndefNulls(formValues);
        const values: Array<ISceneItemNewValues> = [];
        const uiConfigToUse = customUIConfig || this.uiConfigInit;
        uiConfigToUse.forEach((uiConfig) => {
            if (!uiConfig) return;

            if (skipHiddenFields && uiConfig.hideMe) {
                return;
            }

            const key = uiConfig.name;
            const storePath = uiConfig.storePath;
            if (_.isUndefined(storePath)) return;

            let value = formValues[key];
            const storePathNoLeaf = storePath.split('.').slice(0, -1).join('.');
            try {
                switch(uiConfig.type) {
                    case 'radiobutton': {
                        value = String(uiConfig.options.findIndex((v) => v === value));
                        break;
                    }
                    case 'checkbox': {
                        value = value === '1' || value === 'true' || value === true || value == 1 ? '1' : '0';
                        value = uiConfig.options?.[value] || value;
                        break;
                    }
                    case 'select': {
                        // if (uiConfig.options["0"].optionValue) value = uiConfig.options.find((v) => v.optionsLabel == value).optionValue;
                        break;
                    }
                    case 'input': {
                        if (uiConfig.inputType == 'date' && value && value !== '') value = dateStringToUnix(value);
                        if (uiConfig.inputType == 'color' && value && value !== '')  value = Lib.HexToDecimal(value);
                        if (uiConfig.inputType == 'tablelist') {
                            if (skipTableList) return;
                            value = instanceOfTableList(value) ? value.values : value;
                        } 
                        break;
                    }
                    default:
                        break;
                }
            } catch (e) {
                if (uiConfig.ignoreMissingValue) return;
                console.error('problem submitting missing fields ' + e);
                alert('problem submitting missing fields ' + e);
            }
            values.push({key, value, storePath: storePathNoLeaf});
        });
        this.dispatchSceneItemChanges({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: patchBeforeSubmitFunc ? patchBeforeSubmitFunc(values) : values
        });
    }

    public setFormValue(i_field, i_value, i_type = null) {
        if (isNullOrUndef(i_value)) return;

        /** decode base64 values **/
        if (i_field === 'appName64' || i_field === 'cmdLine64') {
            if (i_value.match('=$')) {
                i_value = Lib.Base64().decode(i_value);
            }
        }
        const a = {};
        a[i_field] = i_value;
        this.form?.values(a, i_type);
    }

    public disableForm() {
        if (this.form) {
            this.form.disableForm(true);
        } else {
            // console.log('debug mode no form');
        }
    }

    public swapKeyName(values, name, withName) {
        values.forEach((v) => v.key === name ? v.key = withName : doNothing());
        return values;
    }

    public tableListGetSelected(tableListName: string): Array<number> {
        const dynamic = this.getFormComponentRef(tableListName) as DynamicFieldDirective;
        return dynamic?.componentRef.instance.getTableListInstance().getSelection();
    }

    public tableListSetSelected(tableListName: string, index: Array<number>) {
        const dynamic = this.getFormComponentRef(tableListName) as DynamicFieldDirective;
        dynamic?.componentRef.instance.getTableListInstance().setSelection(index);
    }

    public tableListButtonDisable(tableListName: string, buttonName: string, value: boolean) {
        const dynamic = this.getFormComponentRef(tableListName) as DynamicFieldDirective;
        dynamic?.componentRef.instance.getTableListInstance().disableButton(buttonName, value);
    }

    public tableListSelection(tableListName: string, i_selection: Array<number>) {
        const dynamic = this.getFormComponentRef(tableListName) as DynamicFieldDirective;
        dynamic?.componentRef.instance.getTableListInstance().setSelection(i_selection);
    }

    public enableForm() {
        if (this.form) {
            this.form.disableForm(false);
        } else {
            console.log('debug mode no form');
        }
    }

    public isTouchedForm() {
        return this.form && this.form.isTouchedForm();
    }

    public setUiConfigValue(i_name, i_value, customUIConfig: FieldConfig[] = null) {
        const uiConfigToUse = customUIConfig || this.uiConfigInit;
        const index = uiConfigToUse.findIndex((v, i) => v.name === i_name);
        uiConfigToUse[index].value = i_value;
    }

    public setUiConfigHide(i_name, value: boolean) {
        this.form?.getFields().forEach((k, v) => {
            if (k.field.name === i_name) {
                k.componentRef.instance.hideMe = value;
                k.field.hideMe = value;
            }
        });
    }

    public setUiDisableInput(i_name, value: boolean) {
        this.form?.getFields().forEach((k, v) => {
            if (k.field.name === i_name) {
                k.componentRef.instance.disableInput(value);
            }
        });
    }

    public getFormComponentRef(i_name) {
        return this.form?.getFields().find((k, v) => {
            if (k.field.name === i_name) return k.componentRef;
        });
    }

    public getUniqueId(pre) {
        return _.uniqueId(pre);
    }

    public appendGpu(i_uiConfigInit: FieldConfig[]) {
        return i_uiConfigInit;
        // if (!this.isFullFeatures) return i_uiConfigInit;
        // i_uiConfigInit.push({
        //     type: "checkbox",
        //     value: '1',
        //     label: 'GPU',
        //     name: "gpu",
        //     storePath: '$.gpu'
        // });
        // return i_uiConfigInit;
    }

    /**
     * The component base class supports by default the FontSelector component integration
     **/
    onFontChanged(values: IFontFormat, i_field: string, i_componentName: string, addFontSlice: boolean = false) {
        const changes = [];
        ['fontSize', 'fontColor', 'fontFamily', 'fontWeight', 'fontStyle', 'textDecoration', 'textAlign', 'alignSelf', 'autoScaling', 'wrap'].forEach((k) => {
            changes.push({
                key: k,
                value: values[k],
                storePath: i_field === '' ? `Data[0].${i_componentName}[0].Font[0].$` : `Data[0].${i_componentName}[0].${i_field}[0].Font[0].$`
            });
        });
        if (addFontSlice) {
            this.dispatchSceneItemChanges({
                sceneId: this.sceneId, sceneItemId: this.sceneItem.$.id, values: [{
                    key: 'Font',
                    value: [{$: values}],
                    storePath: i_field === '' ? `Data[0].${i_componentName}[0]` : `Data[0].${i_componentName}[0].${i_field}[0]`
                }]
            });
        }
        this.dispatchSceneItemChanges({sceneId: this.sceneId, sceneItemId: this.sceneItem.$.id, values: changes});
    }

    reloadForm() {
        this.dynamicsInitialized = false;
        setTimeout(() => {
            this.dynamicsInitialized = true;
        }, 100);
    }

    // Touch action functionality - safe to add as optional public methods
    public onTouchAction() {
        this.cod(
            this.storeSelector.getTouchScenes().pipe(
                take(1),
                map(sliders => {
                    // First, check if the current scene IS one of the sliders
                    const currentSceneIsSlider = sliders.find(slider => slider.Player.$.id === this.sceneId);
                    if (currentSceneIsSlider) {
                        return currentSceneIsSlider;
                    }

                    // If not, find the parent slider that contains the current scene
                    return sliders.find(slider => {
                        const players = slider?.Player?.Data?.[0]?.Scene?.[0]?.Players?.[0]?.Player;
                        if (!players || players.length === 0) return false;

                        const componentName = this.getComponentName(slider);
                        const componentPlayer = players.find(p => p.Data?.[0]?.[componentName]);
                        if (!componentPlayer) return false;

                        const pages = componentPlayer.Data[0][componentName][0].Page;
                        if (!pages || pages.length === 0) return false;

                        // Check if current scene is in this slider's pages
                        return pages.some(page =>
                            page?.Player?.[0]?.$?.src === this.sceneId
                        );
                    });
                })
            ).subscribe(sliderScene => {
                if (sliderScene) {
                    this.dialog.open(DialogTouchActionComponent, {
                        width: '500px',
                        data: {
                            sliderScene: sliderScene,
                            newTouchButton: false,
                            offset: null
                        }
                    });
                }
            })
        );
    }

    private getComponentName(sliderScene): 'Collection' | 'Playlist' {
        return this.isCollection(sliderScene) ? 'Collection' : 'Playlist';
    }

    private isCollection(sliderScene): boolean {
        if (!sliderScene) return true;
        const players = sliderScene.Player?.Data?.[0]?.Scene?.[0]?.Players?.[0]?.Player;
        if (!players || players.length === 0) return true;

        const componentPlayer = players.find(p => p.Data?.[0]?.Collection || p.Data?.[0]?.Playlist);
        if (!componentPlayer) return true;

        return !!componentPlayer.Data[0].Collection;
    }
}
